import { render, staticRenderFns } from "./point-b.vue?vue&type=template&id=166faed6&scoped=true&"
import script from "./point-b.vue?vue&type=script&lang=js&"
export * from "./point-b.vue?vue&type=script&lang=js&"
import style0 from "./point-b.vue?vue&type=style&index=0&id=166faed6&prod&scoped=true&lang=css&"
import style1 from "./point-b.vue?vue&type=style&index=1&id=166faed6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166faed6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContent } from 'vuetify/lib/components/VContent';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VChip,VContent,VDivider,VTab,VTabItem,VTabs,VTabsItems})
